import React from "react";
import { Col, Row, Separator } from "styles";
import { Input } from "components/Input";

export function Customer(props) {
  const places = [
    "China",
    "América Latina",
    "América do Norte",
    "Europa",
    "Russia",
    "Oriente Médio",
    "Japão",
  ];

  const placeHandler = (value, place) => {
    const copyBroiler = { ...props.broiler };
    if (value) {
      copyBroiler.exportPlaces.push(place);
    } else {
      const index = copyBroiler.exportPlaces.findIndex(
        (item) => item === place
      );
      if (index > -1) {
        copyBroiler.exportPlaces.splice(index, 1);
      }
    }
    props.setBroiler(copyBroiler);
  };

  return (
    <>
      <Row>
        <Col>
          <Input
            type="input"
            params="dailySlaughter"
            item={props.broiler}
            setItem={props.setBroiler}
            inputType="number"
            label="Abates Diários"
          />
        </Col>
        <Col>
          <Input
            type="select"
            params="healthScore"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Escore sanitário"
            placeholder="Selecione o escore"
            options={props.config
              .filter((item) => item.key === "customerHealthScore")
              .map((item) => ({ value: item.description }))}
          />
        </Col>
        <Col>
          <Input
            type="input"
            params="healthChallenge"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Quais os desafios sanitários?"
          />
        </Col>
        <Col>
          <Input
            item={props.broiler}
            setItem={props.setBroiler}
            params="date"
            type="inputMask"
            label="Data Alteração"
            mask="99/99/9999"
          />
        </Col>
      </Row>
      <Row>
        <Col size={2}>
          <Input
            type="input"
            params="knownAgents"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Os agentes são conhecidos? Se sim, quais são?"
          />
        </Col>
        <Col size={1}>
          <Input
            type="select"
            params="antibiogramRecent"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Foi feito antibiograma recentemente?"
            placeholder="Selecione uma opção"
            options={[
              { value: "Sim", label: "Sim" },
              { value: "Não", label: "Não" },
            ]}
          />
        </Col>
      </Row>
      <Separator />
      <Row>
        <Col flexRow={true}>
          <Input
            type="checkbox"
            params="export"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Exportador"
          />
          <Input
            type="checkbox"
            params="internMarket"
            item={props.broiler}
            setItem={props.setBroiler}
            label="Mercado Interno"
          />
        </Col>
      </Row>
      {props.broiler.export ? (
        <Row>
          <Col size={1}>
            <Input
              type="select"
              params="exportCuts"
              item={props.broiler}
              setItem={props.setBroiler}
              label="Quais Cortes?"
              placeholder="Selecione uma tipo de corte"
            />
          </Col>
          <Col size={3} flexRow={true}>
            {places.map((place) => (
              <Input
                key={place}
                type="checkbox"
                label={place}
                onChange={(e) => placeHandler(e.target.checked, place)}
                checked={
                  props.broiler.exportPlaces.findIndex(
                    (item) => item === place
                  ) > -1
                }
              />
            ))}
          </Col>
        </Row>
      ) : null}
    </>
  );
}
